import { render } from "./DBreadcrumbs.vue?vue&type=template&id=046633da&scoped=true"
import script from "./DBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./DBreadcrumbs.vue?vue&type=script&lang=js"

import "./DBreadcrumbs.vue?vue&type=style&index=0&id=046633da&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046633da"]])

export default __exports__